import { useContext } from 'react';
import { useChatContext } from '../context/ChatContext';

/**
 * useChat hook that consumes the global ChatContext.
 * This ensures that sessions, messages, and state are synchronized across all components.
 */
export const useChat = () => {
  return useChatContext();
};
